export const TOWN = 'Town';
export const HOUSE_1 = 'House_1';
export const HOUSE_2 = 'House_2';

// Types
export type TScenes = typeof TOWN | typeof HOUSE_1 | typeof HOUSE_2;
